export default __webpack_public_path__ + "static/media/the-original-one.db3f2a57.png";